exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".issue-chart {\n  width: 100%;\n  text-align: center;\n}\n\n.issue-chart-header {\n  font-family: \"Google Sans Regular\";\n}\n\n@media (max-width: 1380px) {\n}\n\n@media (max-width: 768px) {\n  .issue-chart-header {\n    font-size: 20px;\n  }\n}\n", ""]);

